import React, { Component } from 'react';
import Img from 'gatsby-image';
import MultiResolutionImage from './MultiResolutionImage';
import black from '../img/black.jpg';
/*
http://via.placeholder.com/176x260?text=8 (176x260)
http://via.placeholder.com/176x260?text=7 (176x260)
http://via.placeholder.com/376x244?text=9 (376x244)
http://via.placeholder.com/776x536?text=10 (776x536)
*/
class Masonry extends Component {
  componentDidMount() {
    if (typeof window === 'undefined') {
      return;
    }
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.resizeTagline);
    //this.handleResize();
    this.resizeTagline();
  }

  componentWillUnmount() {
    if (typeof window === 'undefined') {
      return;
    }
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('load', this.resizeTagline);
  }

  handleResize = () => {
    this.equalize();
    this.resizeTagline();
  };

  resizeTagline = () => {
    if (typeof window === 'undefined') {
      return;
    }
    const tc = this.taglineContainer;
    const t = this.tagline;

    const mh = tc.getBoundingClientRect().height - 100;
    clearTimeout(this.resizeTimeout);
    if (mh < 0 || isNaN(mh)) {
      this.resizeTimeout = setTimeout(this.resizeTagline, 5);
      return;
    }

    let fs = 80;
    t.style.fontSize = `${fs}px`;
    t.style.lineHeight = `${fs - 6}px`;
    let h = t.getBoundingClientRect().height;

    if (h > mh) {
      while (h > mh) {
        fs--;
        t.style.fontSize = `${fs}px`;
        t.style.lineHeight = `${fs - 6}px`;
        h = t.getBoundingClientRect().height;
      }
    }

    t.style.top = `${Math.round(mh * 0.5 - h * 0.5) + 50}px`;
  };

  equalize = () => {
    //this.equalize();
    // const groups = Array.from(
    //   document.querySelectorAll('.has-equal-height-columns')
    // );
    // groups.forEach(group => {
    //   this.equalizeGroup(group);
    // });
    const columns = Array.from(document.querySelectorAll('.column.eq'));
    columns.forEach(col => {
      const img = col.querySelector('img');
      img.style.height = `auto`;
      const h = Math.round(col.getBoundingClientRect().height);

      img.style.height = `${h - 24}px`;
    });
  };

  equalizeGroup = group => {
    // const columns = Array.from(group.querySelectorAll(':scope > .column'));
    // columns.forEach(column => {
    //   column.style.height = `auto`;
    // });
    // let maxHeight = Math.ceil(
    //   Math.max(
    //     ...columns.map(item => {
    //       return item.getBoundingClientRect().height;
    //     })
    //   )
    // );
    // columns.forEach(column => {
    //   column.style.height = `${maxHeight}px`;
    // });
  };

  onImageLoaded = e => {
    console.log(e);
    this.equalize();
    // const img = e.target;
    // const parent = img.parentNode;
    // if (parent.classList.contains('eq')) {
    //   this.equalize();
    // }
  };

  masonryImage(index) {
    const image = this.props.images[index];
    if (image) {
      return <MultiResolutionImage image={image} onLoad={this.onImageLoaded} />;
    }
    return <img src={defaultImages(index)} />;
  }

  render() {
    const { tagline } = this.props;
    // need to re-do this to use grid, not working as-is for responsive
    return (
      <section className="section is-masonry">
        <div className="container">
          <div className="columns is-multiline is-mobile is-centered">
            <div className="is-4-desktop is-12-mobile column is-order-2-mobile is-order-1-tablet">
              <div className="columns is-mobile is-multiline">
                <div className="is-12 column">{this.masonryImage(0)}</div>
                <div className="is-12 column">{this.masonryImage(1)}</div>
              </div>
            </div>
            <div className="is-12-mobile is-4-desktop column is-order-1-mobile is-order-2-tablet">
              <div className="columns is-mobile is-multiline">
                <div className="is-12 column">
                  <div
                    ref={ref => (this.taglineContainer = ref)}
                    className="box has-tagline"
                    style={{
                      backgroundColor: `#020202`,
                      alignItems: `center`,
                      padding: 0,
                      display: `flex`,
                      borderRadius: `0`
                    }}
                  >
                    <img src={black} alt="black-bg" />
                    <p
                      ref={ref => (this.tagline = ref)}
                      className="has-text-weight-condensed is-uppercase is-tagline"
                      style={{
                        color: `white`
                      }}
                    >
                      {tagline}
                    </p>
                  </div>
                </div>
                <div className="is-12 column eq">{this.masonryImage(2)}</div>
              </div>
            </div>
            <div className="is-4-desktop is-12-mobile column is-order-3-mobile is-order-3-tablet">
              <div className="columns is-mobile is-multiline">
                <div className="is-6 column">{this.masonryImage(3)}</div>
                <div className="is-6 column">{this.masonryImage(4)}</div>
                <div className="is-12 column eq">{this.masonryImage(5)}</div>
              </div>
            </div>
          </div>
          <div className="columns is-multiline is-mobile is-centered">
            <div className="is-12-mobile is-4-tablet is-4-desktop column">
              <div className="columns is-mobile is-multiline">
                <div className="is-6 column">{this.masonryImage(6)}</div>
                <div className="is-6 column">{this.masonryImage(7)}</div>
                <div className="is-12 column eq">{this.masonryImage(8)}</div>
              </div>
            </div>
            <div className="is-8-desktop is-8-tablet is-12-mobile column eq">
              {this.masonryImage(9)}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Masonry;



// WEBPACK FOOTER //
// ./src/components/Masonry.js